import React, { useRef, useState } from 'react';
import TableTopHeader from '../TableTopHeader/TableTopHeader';
import ColumnVisibility from '../TableTopHeader/ColumnVisibility';
import * as tableHeader from '../TableHeader/NewAudienceTableHeader';
import TableComponent from '../TableComponent/TableComponent';
import WhiteBoxContainer from '../../HOC/WrappingContainer/WhiteBoxContainer';
import { useExportShowResult } from '../../../Hooks/UserAssignment';
import { useReactToPrint } from 'react-to-print';
import PrintComponent from '../Custom/ExportComponent/PrintComponent';
const NewAudienceTable = ({
  isLoading,
  refetch,
  audienceData,
  valuesToExport,
}) => {
  const printRef = useRef();

  const [visibleColumn, setVisibleColumn] = useState({
    name: true,
    applicationStart_Display: true,
    fieldOfInterest_Display: true,
    mobile: true,
    email: true,
    contactType_Display: true,
    userAssigned: false,
    statusText: false,
    type: true,
    nationality_Display: true,
    howDoYouHear_Display: false,
    // selectedTerm_Display: true,
    noteCount: false,
    emailCount: false,
    sourceOfConnection: false,
    grade_Display: false,
    highSchoolGPA: false,
    curriculum_Display: false,
    lastEmailReceivedOnDisplay: false,
    priority_Display: false,
    country_Display: false,
    jobTitle: false,
    schoolName: false,
    createdOnDisplay: false,
  });
  const exportShowResult = useExportShowResult();

  const combinedData = audienceData
    ? [
        ...(Array.isArray(audienceData?.applicants)
          ? audienceData.applicants.map((applicant) => ({
              ...applicant,
              type: 'applicant',
              id: applicant.applicantId,
              name: applicant.lastName
                ? applicant.firstName +
                  ' ' +
                  applicant.middleName +
                  ' ' +
                  applicant.lastName
                : applicant.firstName,
            }))
          : []),
        ...(Array.isArray(audienceData?.externalContacts)
          ? audienceData.externalContacts.map((contact) => ({
              ...contact,
              type: 'contact',
              id: contact.externalContactId,
              name: contact.contactName,
            }))
          : []),
        ...(Array.isArray(audienceData?.leads)
          ? audienceData.leads.map((lead) => ({
              ...lead,
              type: 'lead',
              id: lead.studentId,
              name: lead.lastName
                ? lead.firstName + ' ' + lead.middleName + ' ' + lead.lastName
                : lead.firstName,
            }))
          : []),
      ]
    : [];
  const handleExport = async () => {
    try {
      const data = await exportShowResult.mutateAsync(valuesToExport);

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'AudienceTable';
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Unexpected data type. Expected Blob.', data);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const tableData = {
    data: {
      items: combinedData.map((item) => ({
        ...item,
        id: item.id,
        fullName: item.lastName
          ? item.firstName + ' ' + item.middleName + ' ' + item.lastName
          : item.firstName,
      })),
    },
    refetch: refetch,
    isLoading: isLoading,
    tableHeader: tableHeader.newAudienceTableHeader,
  };
  const rightButtons = (
    <ColumnVisibility
      tableHeader={tableHeader.newAudienceTableHeader}
      visibleColumn={visibleColumn}
      setVisibleColumn={setVisibleColumn}
    />
  );
  return (
    <WhiteBoxContainer>
      <TableTopHeader
        leftComponent={
          <div>
            <h3 style={{ fontWeight: '500', fontSize: '14px' }}>
              {combinedData?.length} Audience
            </h3>
          </div>
        }
        rightButtons={rightButtons}
        handlePrint={handlePrint}
        exportData={{
          visibleColumn: visibleColumn,
          tableHeader: tableHeader.newAudienceTableHeader,
          fileName: 'NewAudienceExport',
          combinedData: tableData?.data?.items,
          isData: true,
        }}
      />
      <TableComponent
        tableData={tableData}
        isLoading={false}
        // page={usersPage}
        // setPage={setUsersPage}
        // pageSize={usersPageSize}
        // setPageSize={setUsersPageSize}
        visibleColumn={visibleColumn}
        columnVisibility
        isResize
      />
      <div style={{ display: 'none' }}>
        <PrintComponent
          ref={printRef}
          title='Audience Table'
          data={tableData}
        />
      </div>
    </WhiteBoxContainer>
  );
};

export default NewAudienceTable;
